import React, { useState, useRef, useEffect } from "react";

const SearchableSelect = ({
  list = [],
  placeholder = "Choose...",
  value,
  onChange,
  search = false,
  name,
  required = false,
  error,
  touched,
  isValid,
  disabled
}) => {
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const ref = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
        setSearchTerm("");
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  // Filter list based on search
  const filteredList = search
    ? list.filter((item) =>
        item.text?.toLowerCase().includes(searchTerm?.toLowerCase())
      )
    : list;

  // Find selected item based on Formik value
  const selected = list.find((item) => item.value == value) || null;

  const handleSelect = (item) => {
    setOpen(false);
    setSearchTerm("");
    if (onChange) {
      onChange({
        target: { name, value: item.value, type: "select-one" },
      });
    }
  };

  return (
    <div
      className={`dropdown w-100 position-relative ${
        selected ? "has-value" : ""
      }`}
      ref={ref}
    >
      <input
        type="hidden"
        name={name}
        value={value || ""}
        required={required}
      />

      <button
        type="button"
        className={`form-select text-start ${
          error && touched
            ? "is-invalid"
            : !isValid && touched && !error
            ? "is-valid"
            : ""
        }`}
        onClick={() => setOpen(!open)}
        disabled={disabled}                                                                          
      >
        {selected ? selected.text : placeholder}
      </button>

      {error && touched && (
        <div className="invalid-feedback d-block">{error}</div>
      )}

      {open && (
        <div
          className="dropdown-menu show w-100 p-0 mt-1"
          style={{ zIndex: 1050 }}
        >
          {search && (
            <div className="p-2">
              <input
                type="text"
                className="form-control mb-2"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                autoFocus
              />
            </div>
          )}

          <div
            className="list-group"
            style={{ maxHeight: "200px", overflowY: "auto" }}
          >
            {filteredList.length > 0 ? (
              filteredList.map((item) => (
                <button
                  key={item.value}
                  type="button"
                  className={`list-group-item list-group-item-action ${
                    item.value == value ? "active" : ""
                  }`}
                  onClick={() => handleSelect(item)}
                >
                  {item.text}
                </button>
              ))
            ) : (
              <div className="text-muted px-3 py-2">No options</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchableSelect;
